import { Box } from '@material-ui/core';
import { PricingFromCdn } from '@nemuru-eng/js-api-client/slim';
import React from 'react';
import ReactJson from 'react-json-view';

import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

export const PricingsInCdnDialog: React.FC<PricingsInCdnDialog> = ({
  pricingsFromCdn,
  opened,
  setOpened,
  handleClose,
}) => {
  return (
    <NemuruDialog
      avoidDefaultClose
      opened={opened}
      setOpened={setOpened}
      buttons={
        <>
          <StandardButton onClick={handleClose}>
            <Text tId={'CLOSE'} />
          </StandardButton>
        </>
      }
    >
      <Box marginBottom={2}>
        <Font variant={'h3'} color={'title'}>
          <Text tId={'PRICINGS_IN_CDN'} />
        </Font>
      </Box>
      <ReactJson
        src={pricingsFromCdn}
        theme="rjv-default"
        name={null}
        iconStyle="square"
        // @ts-ignore
        enableAdd={false}
        enableEdit={false}
        enableDelete={false}
        enableClipboard={false}
        displayObjectSize={false}
        displayDataTypes={false}
        style={{
          minHeight: 200,
          overflowX: 'auto',
          overflowY: 'clip',
          whiteSpace: 'nowrap',
          lineHeight: '12px',
        }}
      />
    </NemuruDialog>
  );
};

interface PricingsInCdnDialog {
  pricingsFromCdn: PricingFromCdn[];
  opened: boolean;
  setOpened: (opened: boolean) => void;
  handleClose: () => void;
}
